import CardListsListItemController from "../../../card_lists/assets/javascript/card-lists-list-item-controller"

export default class extends CardListsListItemController {
  static targets = ["deleteLink", "editLink"];

  connect() {
    super.connect();
    App.Helpers.listenToCustomEvent(document, "completable:checkbox-update", this.updateDisplay.bind(this));
    App.Helpers.listenToCustomEvent(document, "task-unblock:success", this.refreshListItem.bind(this));
    App.Helpers.listenToCustomEvent(document, "task-block:success", this.refreshListItem.bind(this));
    App.Helpers.listenToCustomEvent(document, "priority:updated", this.refreshListItem.bind(this));
  }

  updateDisplay(event) {
    if (event.detail.task && event.detail.task.id == this.itemID) {
      this.isComplete = event.detail.complete;
    }
  }

  openEditFormMaybe(event) {
    const { listID } = event.detail;
    if (!this.isComplete && listID == this.listID && this.hasEditLinkTarget) {
      this.openInlineListItemForm({ target: this.editLinkTarget });
    }
  }

  removeItemFromListMaybe({ detail }) {
    if (!this.itemType.includes("meeting")) return false;
    const { listItemID } = detail;
    if (listItemID == this.itemID) {
      this.removeItemFromList();
    }
  }

  //
  // GETTERS AND SETTERS
  //

  set isComplete(val) {
    this.element.classList[val ? "add" : "remove"]("complete");
  }

  get isComplete() {
    return this.element.classList.contains("complete");
  }
};



// WEBPACK FOOTER //
// ./app/components/milestones/assets/javascript/milestones-list-item-controller.js